import { GenericTableListTranslations } from './generic-table-list-translations.interface';

export const GERMAN_GENERIC_TABLE_LIST_TRANSLATIONS: GenericTableListTranslations = {
  labels: {
    groupLabel: 'Tabellenliste',
    emptyList: 'Keine Zeilen vorhanden.',
    itemEntry: 'Zeile {index} von {total}',
  },
  buttons: {
    appendItem: 'Zeile hinzufügen',
    appendItemLabel: 'Zeile hinzufügen',
    removeItem: 'Zeile {index} löschen',
  },
};
